import {app} from '../../app';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import {UploadSharedQuestion} from "../../sharedQuestions/UploadSharedQuestion";

export class UploadQuestionComponent {

    protected store:angular.a0.storage.INamespacedStoreService;
    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;
    protected fileUploader:any;

    public sharedQuestion:UploadSharedQuestion;

    question:IQuestion;
    values:{name:string;hash:string;}[] = [];
    uploader:any;

    browseFileActive = true;
    errors           = {
        fileFormat: false,
        fileSize  : false,
        other     : false
    };

    static $inject = ['store', 'SharedQuestionService', 'SessionService', 'FileUploader'];

    constructor(store:angular.a0.storage.INamespacedStoreService, sharedQuestionService:SharedQuestionService, sessionService:ISessionService, FileUploader:any) {
        this.store                 = store;
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService        = sessionService;
        this.fileUploader = FileUploader;
    }

    public $onInit = () => {

        this.sharedQuestion = new UploadSharedQuestion();

        this.uploader = new this.fileUploader({
            url              : '/api/storage/',
            onCompleteItem   : (item, response, status, headers) => {
                if (!response.hash) {
                    this.errors.other = true;
                    return;
                }

                this.values.push({
                    name: item.file.name,
                    hash: response.hash,
                });

                this.update();

                this.errors.other = false;
            },
            onErrorItem      : () => {
                this.errors.other = true;
            },
            autoUpload       : true,
            removeAfterUpload: true,
            headers          : {
                // angular-file-upload is using XMLHttpRequest/iframe, not $http.
                // https://github.com/nervgh/angular-file-upload/issues/119
                'Authorization': 'Bearer ' + localStorage.getItem('id_token')
            },
            withCredentials  : true,
            formData         : [
                { session : this.sessionService.activeSession.id },
                { question: this.question.id }
            ]
        });

        if (this.question.meta.formats && angular.isArray(this.question.meta.formats)) {
            this.uploader.filters.push({
                name: 'fileTypeFilter',
                fn  : (item, options) => {
                    const type = /(?:\.([^.]+))?$/.exec(item.name)[1];
                    if (typeof type === 'undefined') {
                        return false;
                    }

                    return !(this.errors.fileFormat = this.question.meta.formats.indexOf(type) === -1);
                }
            });
        }

        if (this.question.meta.max_size && isFinite(this.question.meta.max_size)) {
            this.uploader.filters.push({
                name: 'fileMaxSizeFilter',
                fn  : (item, options) => {
                    return !(this.errors.fileSize = (item.size / 1024 > this.question.meta.max_size))
                }
            });
        }

        this.setup();
    };

    setup() {
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            for (const value of answer.values) {
                this.values.push(value.value);
            }

            this.update();
        }
    }

    update() {
        let values:IValue[] = [];
        for (const value of this.values) {
            values.push({value: {name: value.name, hash: value.hash}});
        }
        this.sharedQuestion.setValue(values);

        if (!this.question.meta.multiple) {
            this.browseFileActive = this.values.length === 0;
        }

        const maxFiles = this.question.meta.max_files;
        if (maxFiles && isFinite(maxFiles)) {
            this.browseFileActive = this.values.length < maxFiles;
        }
    }

    remove(index:number) {
        this.values.splice(index, 1);
        this.update();
    }

}

app.component('uploadQuestion', {
    templateUrl : 'templates/components/questionTypes/uploadQuestion.html',
    controller  : UploadQuestionComponent,
    controllerAs: 'uploadQuestion',
    bindings    : {
        question            : '<',
        nextQuestionCallback: '&',
    }
});